// GENERATED AUTOMATICALLY
// DON NOT EDIT IT MANUALLY

import * as React from 'react';
import AntdIcon, { AntdIconProps } from '../components/AntdIcon';
import { IconDefinition } from '../types';

const AddPhotoAlternateOutlinedSvg: IconDefinition = {"icon":{"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","focusable":"false"},"children":[{"tag":"g","attrs":{"clip-path":"url(#clip0_123_4666)"},"children":[{"tag":"path","attrs":{"d":"M18 20H4V6h9V4H4a2 2 0 00-2 2v14c0 1.1.9 2 2 2h14a2 2 0 002-2v-9h-2v9zm-7.79-3.17l-1.96-2.36L5.5 18h11l-3.54-4.71-2.75 3.54zM20 4V1h-2v3h-3v2h3v2.99h2V6h3V4h-3z","fill":"currentColor"}}]},{"tag":"defs","attrs":{},"children":[{"tag":"clipPath","attrs":{"id":"clip0_123_4666"},"children":[{"tag":"path","attrs":{"d":"M0 0h24v24H0z","fill":"#fff"}}]}]}]},"name":"add_photo_alternate","theme":"outlined"};

const AddPhotoAlternateOutlined = (
  props: AntdIconProps,
  ref: React.MutableRefObject<HTMLSpanElement>,
) => <AntdIcon {...props} ref={ref} icon={AddPhotoAlternateOutlinedSvg} />;
  AddPhotoAlternateOutlined.displayName = 'AddPhotoAlternateOutlined';

export default React.forwardRef<HTMLSpanElement, AntdIconProps>(AddPhotoAlternateOutlined);
